import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { queryFlowTrackList, saveFlowTrack, getFormCate } from '@/services/form';
export default {
  data: function data() {
    var columns = [{
      title: '申请流水号',
      dataIndex: 'fillId',
      align: 'center',
      width: 20
    }, {
      title: '标题',
      dataIndex: 'formName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 30
    }, {
      title: '',
      dataIndex: 'taskId',
      align: 'center',
      width: 5,
      scopedSlots: {
        customRender: 'taskId'
      }
    }, {
      title: '申请人',
      dataIndex: 'startUserName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 40
    }, {
      title: '类型',
      dataIndex: 'category',
      ellipsis: true,
      align: 'center',
      width: 20
    }, {
      title: '申请时间',
      dataIndex: 'processStartTime',
      ellipsis: true,
      align: 'center',
      width: 30
    }, {
      title: '办理状态',
      dataIndex: 'processStatusName',
      align: 'center',
      width: 15,
      scopedSlots: {
        customRender: 'processStatusName'
      }
    }, {
      title: '概述',
      dataIndex: 'summary',
      width: 20
    }, {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 15,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      fillStautsList: [{
        itemName: '草稿',
        itemKey: 0
      }, {
        itemName: '待审批',
        itemKey: 1
      }, {
        itemName: '审批中',
        itemKey: 2
      }, {
        itemName: '审批通过',
        itemKey: 3
      }, {
        itemName: '审批驳回',
        itemKey: 4
      }, {
        itemName: '审核作废',
        itemKey: 5
      }, {
        itemName: '审核挂起',
        itemKey: 6
      }],
      expand: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      form: {
        summary: '',
        fillId: '',
        formName: undefined,
        cateId: '',
        isRead: '',
        time: [],
        startTime: '',
        endTime: '',
        processStatusName: undefined,
        category: undefined
      },
      loading: false,
      list: [],
      pagination: this.$hdk.page(),
      columns: columns,
      cateList: [],
      visibleId: '',
      visible: false
    };
  },
  created: function created() {
    var savedPagination = sessionStorage.getItem('Pagination_processTrack');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.getList();
    this.getForm();
  },
  methods: {
    handleVisibleChange: function handleVisibleChange(row) {
      // if (row.trackStatus == 2) {
      //     this.visible = true;
      // }
    },
    handlepopConfirmConfirm: function handlepopConfirmConfirm(row) {
      var _this = this;
      saveFlowTrack(row).then(function (res) {
        _this.visible = false;
        _this.getList();
      });
    },
    handlepopConfirmCancel: function handlepopConfirmCancel() {
      this.visible = false;
    },
    getForm: function getForm() {
      var _this2 = this;
      getFormCate().then(function (res) {
        _this2.cateList = res.data.data;
      });
    },
    cz: function cz() {
      this.$refs.searchFrom.resetFields();
    },
    search: function search() {
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.getList();
      sessionStorage.removeItem('Pagination_processTrack');
    },
    toSave: function toSave(row) {
      this.visibleId = row.processInstanceId || row.procInsId;
      this.visible = true;

      // saveFlowTrack(row).then(res => {
      //     console.log(res);
      //     this.getList();
      // });
    },
    view: function view(record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.processInstanceId
        }
      });
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    change: function change(pagination) {
      this.getList({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
      sessionStorage.setItem('Pagination_processTrack', JSON.stringify(this.pagination));
    },
    getList: function getList(options) {
      var _this3 = this;
      var pagination = this.pagination,
        form = this.form,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.form.time.length > 0) {
        this.form.startTime = this.form.time[0];
        this.form.endTime = this.form.time[1];
      } else {
        this.form.startTime = null;
        this.form.endTime = null;
      }
      if (!pager.form) {
        pager.form = form;
      }
      queryFlowTrackList(pager.current, pager.pageSize, pager.form).then(function (res) {
        _this3.list = res.data.data.rows;
        _.assign(pagination, {
          total: res.data.data.total,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(form, pager.form);
      }).finally(function () {
        _this3.loading = false;
      });
    }
  }
};